import { render, staticRenderFns } from "./AppList1.vue?vue&type=template&id=67f47480&scoped=true&"
import script from "./AppList1.vue?vue&type=script&lang=js&"
export * from "./AppList1.vue?vue&type=script&lang=js&"
import style0 from "./AppList1.vue?vue&type=style&index=0&id=67f47480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f47480",
  null
  
)

export default component.exports